export default function LinearDial({ 
    fillPercentage = 50, 
    fillLabel = 'Fill Label', 
    emptyLabel = 'Empty Label' 
}) {

    return (
        <div>
            {/* Bar */}
            <div className="bg-gray-300 w-full h-6 rounded-lg overflow-hidden">
                <div 
                    className="h-6 w-1/3 bg-orange-400" 
                    style={{ width: fillPercentage + '%' }} 
                />
            </div>

            {/* Labels */}
            <div className="flex pt-1 px-1">
                
                <p className="flex-grow text-left text-sm text-orange-400">
                    {fillLabel}
                </p>

                <p className="text-sm text-gray-400">{emptyLabel}</p>
            </div>
        </div>
    )

}